(function () {
	'use strict';

	try{if(typeof document != 'undefined'){var elementStyle = document.createElement('style');elementStyle.appendChild(document.createTextNode("._host_elpmp_1 {\n    display: flex;\n    align-items: center;\n    margin-top: 8px;\n    font-family: var(--font-family);\n}\n\n._indicator_elpmp_8 {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n\n    width: 1.2rem;\n    height: 1.2rem;\n\n    color: var(--axa-fr-text-disabled);\n    fill: var(--axa-fr-text-disabled);\n\n    margin-right: 8px;\n}\n\n._invalid_elpmp_22 {\n    color: var(--axa-fr-text-disabled);\n    fill: var(--axa-fr-text-disabled);\n}\n\n._valid_elpmp_27 {\n    color: var(--axa-fr-text-success);\n    fill: var(--axa-fr-text-success);\n}\n\n._error_elpmp_32 {\n    color: var(--axa-fr-text-error);\n    fill: var(--axa-fr-text-error);\n}\n\n._warning_elpmp_37 {\n    color: var(--axa-fr-text-warning);\n    fill: var(--axa-fr-text-warning);\n}\n\n._text_elpmp_42 {\n    font-size: 1.4rem;\n    line-height: 2.1rem;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n._host_1meie_1 {\n    position: relative;\n    display: inline-flex;\n    justify-content: left;\n    align-items: center;\n\n    color: var(--axa-fr-text-secondary);\n    font-family: var(--font-family);\n    font-size: 1.8rem;\n    font-weight: 500;\n\n    user-select: none;\n    width: 100%;\n    min-width: 14.4rem;\n    max-width: 50rem;\n    height: 5rem;\n}\n\n._size_small_1meie_19 {\n    max-width: 17.2rem;\n}\n\n._size_medium_1meie_23 {\n    max-width: 32.8rem;\n}\n\n._size_large_1meie_27 {\n    max-width: 57.2rem;\n}\n\n._host_1meie_1 ._input_1meie_31 {\n    width: 100%;\n    height: 100%;\n    padding: 0 15px;\n    outline: 0;\n    margin: 0;\n    font-size: 1.6rem;\n    line-height: 2.8rem;\n    border: var(--border-width) solid var(--axa-fr-text-neutral-20);\n    color: var(--axa-fr-text-secondary);\n}\n\n._host_1meie_1 ._input_1meie_31._size_text_small_1meie_43 {\n    height: 5rem;\n}\n\n._host_1meie_1 ._input_1meie_31._size_text_medium_1meie_47 {\n    height: 6rem;\n}\n\n._host_1meie_1 ._input_1meie_31:focus,\n._host_1meie_1 ._input_1meie_31:focus-visible {\n    box-shadow: 0 4px 16px -2px rgba(var(--color-primary40-rgb), 0.2);\n}\n\n._host_1meie_1 ._input_1meie_31:focus,\n._host_1meie_1 ._input_1meie_31:focus-visible,\n._host_1meie_1 ._input_1meie_31:valid,\n._host_1meie_1 ._input_1meie_31:hover,\n._host_1meie_1 ._input_1meie_31._valid_1meie_60,\n._host_1meie_1 ._input_1meie_31:focus:valid,\n._host_1meie_1 ._input_1meie_31:focus:invalid {\n    border-color: var(--axa-fr-border-select);\n}\n\n._host_1meie_1 ._input_1meie_31:disabled,\n._host_1meie_1 ._input_1meie_31:read-only {\n    border-color: rgba(153, 153, 153, 0.48);\n    background-color: var(--axa-fr-button-disabled-bg);\n    color: rgba(var(--color-neutral80-rgb), 0.77);\n}\n\n._host_1meie_1 ._input_1meie_31._error_1meie_73 {\n    border-color: var(--axa-fr-border-error);\n    \n    &:focus{\n        border-color: var(--axa-fr-border-error);\n        box-shadow: 0 4px 16px -2px rgba(var(--color-error-40-rgb), 0.2);\n    }\n}\n\n._host_1meie_1 ._input_1meie_31._warning_1meie_82 {\n    border-color: var(--axa-fr-text-warning);\n}\n\n/* endAdornment.right (16) + endAdornment.width (24) + padding-left (24)*/\n._host_1meie_1 ._input_1meie_31._with_end_adornment_1meie_87 {\n    padding-right: 54px;\n}\n\n._host_1meie_1 ._endAdornment_1meie_91 {\n    position: absolute;\n    right: 16px;\n    height: 2.4rem;\n    width: 2.4rem;\n    fill: var(--axa-fr-icon-primary);\n}\n\ninput::-webkit-calendar-picker-indicator {\n    display: none;\n}\n\ninput[type='date']::-webkit-input-placeholder {\n    visibility: hidden !important;\n}\n\ninput[type='date'] {\n    font-family: var(--font-family);\n}\n\n@media only screen and (max-width: 668px) {\n    ._host_1meie_1 ._input_1meie_31._size_small_1meie_19,\n    ._host_1meie_1 ._input_1meie_31._size_medium_1meie_23,\n    ._host_1meie_1 ._input_1meie_31._size_large_1meie_27 {\n        max-width: 100%;\n    }\n}\n._container_k3d3o_1 {\n    display: flex;\n    align-items: center;\n    margin-block-end: var(--axa-fr-spacing-01);\n}\n\n._justifyContentSpaceBetween_k3d3o_7 {\n    justify-content: space-between;\n}\n\n._label_k3d3o_11 {\n    color: var(--axa-fr-text-secondary);\n    display: block;\n    padding: 0;\n    font-family: var(--font-family);\n    font-size: 1.8rem;\n    font-weight: 400;\n    line-height: 1.5em;\n}\n\n._larger_k3d3o_21 {\n    color: var(--axa-fr-text-primary);\n    font-family: var(--font-family);\n    font-size: 2.4rem;\n    font-weight: 600;\n    margin-bottom: var(--axa-fr-spacing-03);\n}\n\n._tooltip_k3d3o_29 {\n    margin-left: 0.8rem;\n}\n._host_1xdcr_1 {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    /* TODO : Centralize this value, as well as the size_* variants below in order to dedup them from Input.module.css */\n    max-width: 50rem;\n    width: 100%;\n}\n\n._host_1xdcr_1._size_small_1xdcr_10 {\n    max-width: 17.2rem;\n}\n\n._host_1xdcr_1._size_medium_1xdcr_14 {\n    max-width: 32.8rem;\n}\n\n._host_1xdcr_1._size_large_1xdcr_18 {\n    max-width: 57.2rem;\n}\n\n._host_1xdcr_1 ._label_1xdcr_22 {\n    display: inline-block;\n    color: var(--color-variant);\n    font-size: 1.8rem;\n    font-weight: 400;\n    line-height: 2rem;\n\n    font-family: var(--font-family);\n}\n\n._host_1xdcr_1 ._controls_1xdcr_32 {\n    display: inline-flex;\n    align-items: center;\n}\n\n._host_1xdcr_1 ._main_1xdcr_37 {\n    align-items: center;\n    justify-content: start;\n    flex: auto;\n}\n\n._host_1xdcr_1 ._helpText_1xdcr_43 {\n    color: var(--color-variant);\n}\n._container_txlcn_1 {\n    position: relative;\n}\n\n._combobox_txlcn_5 {\n    display: inline-block;\n    border: var(--border-width) solid var(--axa-fr-text-neutral-20);\n    border-radius: 0;\n    width: 100%;\n    height: 5.2rem;\n    padding: 5px 15px;\n\n    font-family: var(--font-family);\n    font-size: 1.5rem;\n    color: var(--axa-fr-text-secondary);\n}\n\n._combobox_txlcn_5:focus,\n._combobox_txlcn_5:focus-visible,\n._combobox_txlcn_5:valid,\n._combobox_txlcn_5:hover,\n._combobox_txlcn_5._valid_txlcn_22,\n._combobox_txlcn_5:focus:invalid {\n    border-color: var(--axa-fr-border-select);\n    outline: none;\n}\n\n._combobox_txlcn_5:focus,\n._combobox_txlcn_5:focus-visible {\n    box-shadow: 4px 0 16px rgba(var(--color-primary40-rgb), 0.2);\n}\n\n._combobox_txlcn_5._error_txlcn_33 {\n    border-color: var(--axa-fr-border-error);\n}\n\n._icon_txlcn_37 {\n    position: absolute;\n    margin: 0;\n    right: 0;\n    border: 0;\n    height: 100%;\n    padding: 0 10px;\n    background-color: transparent;\n\n    font-size: 1.5rem;\n\n    cursor: pointer;\n}\n\n._listbox_txlcn_51 {\n    position: relative;\n    top: 100%;\n    margin: 0;\n    border: var(--border-width) solid var(--color-variant);\n    border-top: 0;\n    width: 100%;\n    max-height: 25rem;\n    padding: 0;\n\n    background-color: white;\n    list-style: none;\n    color: var(--color);\n    overflow: auto;\n}\n\n._option_txlcn_67 {\n    padding: 5px 15px;\n\n    font-family: var(--font-family);\n    font-size: 1.5rem;\n    cursor: pointer;\n}\n\n._option_txlcn_67:hover,\n._option_txlcn_67[aria-selected=\"true\"] {\n    background: #F5F5F5;\n    color: #3032C1;\n}"));document.head.appendChild(elementStyle);}}catch(e){console.error('vite-plugin-css-injected-by-js', e);}

})();
import { jsx, jsxs } from 'react/jsx-runtime';
import classNames from 'classnames';
import { IconCheck1, IconClear, IconDangerO } from '@axafr-btc-ds/icons';
import { useRef, useState, useEffect, useId, Children, cloneElement } from 'react';
import { isRegExp } from '@axa-fr-axion/utils';
import { useUpdateEffect } from 'usehooks-ts';
import { Tooltip, Direction, getElementBounds } from '@axafr-btc-ds/tooltip';

const host$2 = "_host_elpmp_1";
const indicator = "_indicator_elpmp_8";
const invalid = "_invalid_elpmp_22";
const valid$2 = "_valid_elpmp_27";
const error$2 = "_error_elpmp_32";
const warning$1 = "_warning_elpmp_37";
const text = "_text_elpmp_42";
const styles$4 = {
	host: host$2,
	indicator: indicator,
	invalid: invalid,
	valid: valid$2,
	error: error$2,
	warning: warning$1,
	text: text
};

function selectStyle(level) {
  switch (level) {
    case "warning":
      return styles$4.warning;
    case "error":
      return styles$4.error;
    case "valid":
      return styles$4.valid;
    default:
      return styles$4.invalid;
  }
}
function selectIcon(level) {
  switch (level) {
    case "warning":
      return /* @__PURE__ */ jsx(IconDangerO, {});
    case "error":
      return /* @__PURE__ */ jsx(IconClear, {});
    case "valid":
    default:
      return /* @__PURE__ */ jsx(IconCheck1, {});
  }
}

function AssistiveText(props) {
  const {
    isIconVisible = true,
    level,
    classNameText,
    classNameIcon,
    text
  } = props;
  const textClassNames = [styles$4.text, classNameText, selectStyle(level)];
  const indicatorClassNames = [styles$4.indicator, classNameIcon, selectStyle(level)];
  const icon = selectIcon(level);
  return /* @__PURE__ */ jsxs("div", { className: styles$4.host, children: [
    isIconVisible && /* @__PURE__ */ jsx("span", { className: classNames(indicatorClassNames), children: icon }),
    /* @__PURE__ */ jsx("span", { className: classNames(textClassNames), children: text })
  ] });
}

const host$1 = "_host_1meie_1";
const size_small$1 = "_size_small_1meie_19";
const size_medium$1 = "_size_medium_1meie_23";
const size_large$1 = "_size_large_1meie_27";
const input = "_input_1meie_31";
const size_text_small = "_size_text_small_1meie_43";
const size_text_medium = "_size_text_medium_1meie_47";
const valid$1 = "_valid_1meie_60";
const error$1 = "_error_1meie_73";
const warning = "_warning_1meie_82";
const with_end_adornment = "_with_end_adornment_1meie_87";
const endAdornment = "_endAdornment_1meie_91";
const styles$3 = {
	host: host$1,
	size_small: size_small$1,
	size_medium: size_medium$1,
	size_large: size_large$1,
	input: input,
	size_text_small: size_text_small,
	size_text_medium: size_text_medium,
	valid: valid$1,
	error: error$1,
	warning: warning,
	with_end_adornment: with_end_adornment,
	endAdornment: endAdornment
};

function maskedValue(val, masked) {
  if (typeof masked === "function") {
    return masked(val);
  } else if (isRegExp(masked)) {
    return val.replace(masked, "");
  }
  return val;
}
function getStyleSizeText(sizeText) {
  return sizeText === "S" ? styles$3.size_text_small : styles$3.size_text_medium;
}
function getStyleSize(sizeInput) {
  if (sizeInput === "M") {
    return styles$3.size_medium;
  } else if (sizeInput === "S") {
    return styles$3.size_small;
  }
  return styles$3.size_large;
}
function getStyleBorder(validityStatus) {
  if (validityStatus === "Invalid") {
    return styles$3.error;
  } else if (validityStatus === "Warning") {
    return styles$3.warning;
  } else if (validityStatus === "Valid") {
    return styles$3.valid;
  }
  return "";
}
function stopEventWhenValueSet(value, evt) {
  if (value !== void 0) {
    evt.preventDefault();
    evt.stopPropagation();
  }
}
function pasteString(value = "", newValue, selectionStart, selectionEnd) {
  return value?.slice(0, selectionStart) + newValue + value?.slice(selectionEnd);
}
const buildDescribedByAttribute = (id, validityStatus) => ["Invalid", "Warning"].includes(validityStatus) ? `${id}-error` : void 0;

const UNKNOWN_ERROR_MESSAGE = "Unknown error message";
const BUILT_IN_CONSTRAINT_VIOLATION_KEYS = [
  "badInput",
  "patternMismatch",
  "rangeOverflow",
  "rangeUnderflow",
  "stepMismatch",
  "tooLong",
  "tooShort",
  "typeMismatch",
  "valueMissing"
];
function getBuiltInConstraintViolation(validity) {
  return BUILT_IN_CONSTRAINT_VIOLATION_KEYS.find((item) => validity[item]);
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_debounce = debounce;

const debounce$1 = /*@__PURE__*/getDefaultExportFromCjs(lodash_debounce);

const useValidation = ({
  ref,
  defaultErrorMessage,
  errorMessageForBuiltInConstraintViolations,
  customConstraintViolationValidator,
  validationOnTheFly,
  validationOnTheFlyDelay = 1e3
}) => {
  const internalRef = useRef({});
  const [validityStatus, setValidityStatus] = useState("Pristine");
  const [message, setMessage] = useState(void 0);
  const [customErrorMessage, setCustomErrorMessage] = useState("");
  const setStatesToBeValid = () => {
    setValidityStatus("Valid");
    setCustomErrorMessage("");
    setMessage(void 0);
  };
  const setStatesToBeWithBuiltInError = (msg) => {
    setValidityStatus("Invalid");
    setCustomErrorMessage("");
    setMessage(msg);
  };
  const setStatesToBeWithCustomMessage = (newValidityStatus, msg) => {
    setValidityStatus(newValidityStatus);
    setCustomErrorMessage(msg);
    setMessage(msg);
  };
  const handleAsyncValidate = ([newValidityStatus, msg]) => {
    if (newValidityStatus !== "Valid") {
      setStatesToBeWithCustomMessage(newValidityStatus, msg);
      return;
    }
    setStatesToBeValid();
  };
  const handleValidation = (value, validity) => {
    if (internalRef.current.previousValue === value) {
      return;
    }
    internalRef.current.previousValue = value;
    const constraintViolation = getBuiltInConstraintViolation(validity);
    if (!!constraintViolation) {
      const errorMessage = errorMessageForBuiltInConstraintViolations?.[constraintViolation] || defaultErrorMessage || UNKNOWN_ERROR_MESSAGE;
      setStatesToBeWithBuiltInError(errorMessage);
      return;
    }
    const validateResponse = customConstraintViolationValidator?.(value) || ["Valid"];
    if (validateResponse instanceof Promise) {
      setValidityStatus("Pending");
      validateResponse.then(handleAsyncValidate);
      return;
    } else if (validateResponse[0] !== "Valid") {
      setStatesToBeWithCustomMessage(...validateResponse);
      return;
    }
    setStatesToBeValid();
  };
  const handleEvent = (event) => {
    const { value, validity } = event.target;
    handleValidation(value, validity);
  };
  useEffect(() => {
    let inputElm;
    let handleEventDebounced;
    if (!!ref.current) {
      inputElm = ref.current;
      if (!!inputElm.value) {
        handleValidation(inputElm.value, inputElm.validity);
      } else if (!inputElm.required) {
        setValidityStatus("Valid");
      }
      inputElm.addEventListener("blur", handleEvent);
      inputElm.addEventListener("autofill", handleEvent);
      if (validationOnTheFly) {
        handleEventDebounced = debounce$1(handleEvent, validationOnTheFlyDelay);
        inputElm.addEventListener("input", handleEventDebounced);
      }
    }
    return () => {
      inputElm?.removeEventListener("blur", handleEvent);
      inputElm?.removeEventListener("autofill", handleEvent);
      inputElm?.removeEventListener("input", handleEventDebounced);
    };
  }, [ref]);
  useEffect(() => {
    if (!!ref.current) {
      const inputElm = ref.current;
      inputElm.setCustomValidity(customErrorMessage);
    }
  }, [ref, customErrorMessage]);
  return {
    validityStatus,
    message
  };
};

function useAutofill({ onAutofill, ref }) {
  const handleInput = (evt) => {
    if (document.activeElement !== evt.target) {
      const inputElm = evt.target;
      const value = inputElm?.value;
      const validity = inputElm?.validity;
      setTimeout(() => {
        ref?.current?.dispatchEvent(new Event("autofill", {
          bubbles: true
        }));
        onAutofill?.(value, validity);
      });
    }
  };
  useEffect(() => {
    let inputElm;
    if (ref?.current) {
      inputElm = ref.current;
      inputElm.addEventListener("input", handleInput);
    }
    return () => inputElm?.removeEventListener("input", handleInput);
  }, [ref]);
}

const useEffectiveId = (id) => {
  const localId = useId();
  return id || localId;
};
function Input({
  name,
  id,
  value,
  defaultValue,
  endAdornment,
  onBlur,
  onChange,
  masked,
  type = "text",
  maxLength,
  sizeText = "S",
  sizeInput = "L",
  customConstraintViolationValidator,
  validationOnTheFly = false,
  validationOnTheFlyDelay,
  defaultErrorMessage,
  errorMessageForBuiltInConstraintViolations,
  ...restProps
}) {
  const effectiveId = useEffectiveId(id);
  const ref = useRef(null);
  const { validityStatus, message } = useValidation({
    ref,
    customConstraintViolationValidator,
    defaultErrorMessage,
    errorMessageForBuiltInConstraintViolations,
    validationOnTheFly,
    validationOnTheFlyDelay
  });
  useAutofill({
    ref
  });
  useUpdateEffect(() => {
    const valueMasked = maskedValue(value || "", masked);
    onChange?.(valueMasked, validityStatus, message);
  }, [validityStatus, message]);
  const classNameInput = [
    styles$3.input,
    getStyleSizeText(sizeText),
    getStyleBorder(validityStatus),
    Boolean(endAdornment) && styles$3.with_end_adornment
  ];
  const handleChange = (evt) => {
    const { value: newValue } = evt.target;
    const trimmedValue = newValue.trimStart();
    const valueMasked = maskedValue(trimmedValue, masked);
    valueMasked !== value && onChange?.(valueMasked, validityStatus, message);
  };
  const handleBlur = (evt) => {
    const { value: newValue } = evt.target;
    const trimmedValue = newValue.trim();
    onBlur?.(maskedValue(trimmedValue, masked), validityStatus, message);
  };
  const handlePaste = (evt) => {
    const { selectionStart, selectionEnd } = evt.currentTarget;
    const trimmedValue = evt.clipboardData?.getData("text").trim();
    const newValue = maskedValue(trimmedValue, masked);
    const valuePaste = pasteString(
      value || defaultValue,
      newValue,
      selectionStart,
      selectionEnd
    );
    onChange?.(valuePaste, validityStatus, message);
    stopEventWhenValueSet(value, evt);
  };
  const propsValue = {};
  if (value === void 0) {
    propsValue.defaultValue = maskedValue(defaultValue || "", masked);
  } else {
    propsValue.value = maskedValue(value || "", masked);
  }
  return /* @__PURE__ */ jsxs("div", { className: classNames(styles$3.host, getStyleSize(sizeInput), restProps.className), children: [
    /* @__PURE__ */ jsx(
      "input",
      {
        ...restProps,
        ...propsValue,
        ref,
        id: effectiveId,
        name,
        onChange: handleChange,
        onBlur: handleBlur,
        onPaste: handlePaste,
        className: classNames(classNameInput),
        type,
        maxLength,
        "aria-invalid": validityStatus === "Invalid",
        "aria-describedby": buildDescribedByAttribute(effectiveId, validityStatus),
        "aria-label": restProps.title
      }
    ),
    endAdornment && /* @__PURE__ */ jsx("span", { "data-testid": "endAdornment", className: styles$3.endAdornment, children: endAdornment })
  ] });
}

const container$1 = "_container_k3d3o_1";
const justifyContentSpaceBetween = "_justifyContentSpaceBetween_k3d3o_7";
const label$1 = "_label_k3d3o_11";
const larger = "_larger_k3d3o_21";
const tooltip = "_tooltip_k3d3o_29";
const styles$2 = {
	container: container$1,
	justifyContentSpaceBetween: justifyContentSpaceBetween,
	label: label$1,
	larger: larger,
	tooltip: tooltip
};

function InputLabel({
  id,
  htmlFor,
  title,
  variant,
  tooltipMessage,
  tooltipDirection = Direction.down,
  tooltipContainerBounds = getElementBounds(document.body),
  justifyContentSpaceBetween
}) {
  let variantStyle;
  if (variant === "larger") {
    variantStyle = styles$2.larger;
  }
  let justifyContent;
  if (justifyContentSpaceBetween) {
    justifyContent = styles$2.justifyContentSpaceBetween;
  }
  return /* @__PURE__ */ jsxs("div", { className: classNames(styles$2.container, justifyContent), children: [
    /* @__PURE__ */ jsx(
      "label",
      {
        id,
        className: classNames(styles$2.label, variantStyle),
        htmlFor,
        children: title
      }
    ),
    !!tooltipMessage && /* @__PURE__ */ jsx(
      Tooltip,
      {
        className: styles$2.tooltip,
        direction: tooltipDirection,
        containerBounds: tooltipContainerBounds,
        children: tooltipMessage
      }
    )
  ] });
}

const host = "_host_1xdcr_1";
const size_small = "_size_small_1xdcr_10";
const size_medium = "_size_medium_1xdcr_14";
const size_large = "_size_large_1xdcr_18";
const label = "_label_1xdcr_22";
const controls = "_controls_1xdcr_32";
const main = "_main_1xdcr_37";
const helpText = "_helpText_1xdcr_43";
const styles$1 = {
	host: host,
	size_small: size_small,
	size_medium: size_medium,
	size_large: size_large,
	label: label,
	controls: controls,
	main: main,
	helpText: helpText
};

function getTextLevelFromValidityStatus(validityStatus) {
  switch (validityStatus) {
    case "Invalid":
      return "error";
    case "Warning":
      return "warning";
    case "Valid":
    case "Pending":
    default:
      return "valid";
  }
}

function ValidationIndicator({
  helpText,
  title,
  children,
  validityStatus,
  message,
  showIcon = true,
  showErrorMessage = true,
  classNameRoot,
  classNameInput,
  id,
  tooltipMessage,
  tooltipDirection,
  tooltipContainerBounds,
  justifyContentSpaceBetween
}) {
  return /* @__PURE__ */ jsxs("div", { className: classNames(styles$1.host, classNameRoot), children: [
    /* @__PURE__ */ jsx(
      InputLabel,
      {
        htmlFor: id,
        title,
        tooltipMessage,
        tooltipDirection,
        tooltipContainerBounds,
        justifyContentSpaceBetween
      }
    ),
    /* @__PURE__ */ jsx("div", { className: styles$1.controls, children: /* @__PURE__ */ jsx("div", { className: classNames(styles$1.main, classNameInput), children }) }),
    ["Invalid", "Warning"].includes(validityStatus) && showErrorMessage && /* @__PURE__ */ jsx(
      "div",
      {
        id: `${id}-error`,
        "aria-live": "polite",
        children: /* @__PURE__ */ jsx(
          AssistiveText,
          {
            isIconVisible: showIcon,
            text: message || "",
            level: getTextLevelFromValidityStatus(validityStatus)
          }
        )
      }
    ),
    helpText && /* @__PURE__ */ jsx("p", { className: classNames(styles$1.helpText), children: helpText })
  ] });
}

function InputTextWithValidation({
  onBlur,
  onChange,
  name,
  title,
  showErrorMessage,
  defaultErrorMessage = "Votre champ semble incorrect",
  value = "",
  tooltipMessage,
  tooltipDirection,
  tooltipContainerBounds,
  justifyContentSpaceBetween,
  ...props
}) {
  const id = useId();
  const [validityStatus, setValidityStatus] = useState("Pristine");
  const [message, setMessage] = useState();
  const [valueInput, setValueInput] = useState(value);
  useEffect(() => {
    value !== valueInput && setValueInput(value);
  }, [value]);
  const handleChange = (newValue, newValidityStatus, newMessage) => {
    setValueInput(newValue);
    setValidityStatus(newValidityStatus);
    setMessage(newMessage);
    onChange?.(newValue, newValidityStatus, newMessage);
  };
  const handleBlur = (newValue, newValidityStatus, newMessage) => {
    setValueInput(newValue);
    setValidityStatus(newValidityStatus);
    setMessage(newMessage);
    onBlur?.(newValue, newValidityStatus, newMessage);
  };
  return /* @__PURE__ */ jsx(
    ValidationIndicator,
    {
      id,
      title,
      validityStatus,
      message,
      showErrorMessage,
      tooltipMessage,
      tooltipDirection,
      tooltipContainerBounds,
      justifyContentSpaceBetween,
      children: /* @__PURE__ */ jsx(
        Input,
        {
          ...props,
          id,
          title,
          name,
          defaultErrorMessage,
          onBlur: handleBlur,
          onChange: handleChange,
          value: valueInput
        }
      )
    }
  );
}

const metaData$1 = {
  name: "city",
  title: "Ville*",
  required: true,
  defaultErrorMessage: "La ville semble incorrecte"
};
function InputCity(props) {
  return /* @__PURE__ */ jsxs("div", { className: classNames(styles$1.host, props.classNameRoot), children: [
    /* @__PURE__ */ jsx(InputTextWithValidation, { ...metaData$1, ...props }),
    props.helpText && /* @__PURE__ */ jsx("p", { className: classNames(props.className, styles$1.helpText), children: props.helpText })
  ] });
}

const MAX_ALLOWED_DATE$1 = "9999-12-31";
function InputDate({
  max,
  ...restProps
}) {
  const maxProps = max && new Date(max) < new Date(MAX_ALLOWED_DATE$1) ? max : MAX_ALLOWED_DATE$1;
  return /* @__PURE__ */ jsx(
    Input,
    {
      ...restProps,
      placeholder: "JJ/MM/AAAA",
      max: maxProps
    }
  );
}

const MAX_ALLOWED_DATE = "9999-12-31";
const YEAR_PARTS = 2;
function getValidityDateStatus(dateString, max = MAX_ALLOWED_DATE, min) {
  const regex = /^([0-2][0-9]|(3)[0-1])\/(0[1-9]|1[0-2])\/([0-9]{4})$/;
  if (!regex.test(dateString)) {
    return ["Invalid", "badInput"];
  }
  const parts = dateString.split("/");
  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10);
  const year = parseInt(parts[YEAR_PARTS], 10);
  const date = new Date(year, month - 1, day);
  let valid = date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
  if (!valid) {
    return ["Invalid", "valueMissing"];
  }
  if (min) {
    valid = date.getTime() > new Date(min).getTime();
    if (!valid) {
      return ["Invalid", "rangeUnderflow"];
    }
  }
  valid = date.getTime() < new Date(max).getTime();
  if (!valid) {
    return ["Invalid", "rangeOverflow"];
  }
  return ["Valid"];
}
const toEnglishFormat = (date, separator = "-") => {
  return date.split("/").reverse().join(separator);
};

function InputDateWithValidation({
  name = "birthdate",
  title = "Date de naissance (JJ/MM/AAAA)",
  value = "",
  onBlur,
  onChange,
  onError,
  classNameInput,
  classNameRoot,
  ...restProps
}) {
  const id = useId();
  const [valueInput, setValueInput] = useState(value || "");
  const [validityStatus, setValidityStatus] = useState("Pristine");
  const [message, setMessage] = useState();
  const handleChange = (newValue, newValidityStatus, newMessage) => {
    const formattedValue = newValue.replace(/^(\d\d)(\d)$/g, "$1/$2").replace(/^(\d\d\/\d\d)(\d+)$/g, "$1/$2").replace(/[^\d/]/g, "");
    setValueInput(formattedValue);
    setValidityStatus(newValidityStatus);
    setMessage(newMessage);
    onChange?.(formattedValue, newValidityStatus, newMessage);
  };
  const handleBlur = (newValue, newValidityStatus, newMessage) => {
    setValueInput(newValue);
    setValidityStatus(newValidityStatus);
    setMessage(newMessage);
    onBlur?.(newValue, newValidityStatus, newMessage);
  };
  const handleValidation = (dateValue) => {
    const [status, errorKey] = getValidityDateStatus(
      dateValue,
      restProps.max?.toString(),
      restProps.min?.toString()
    );
    return [
      status,
      restProps.errorMessageForBuiltInConstraintViolations?.[errorKey] ?? restProps.defaultErrorMessage
    ];
  };
  const field = {
    input: {
      ...restProps,
      id,
      value: valueInput,
      onChange: handleChange,
      onBlur: handleBlur
    },
    validator: {
      title,
      id,
      validityStatus,
      message,
      classNameInput,
      classNameRoot
    }
  };
  return /* @__PURE__ */ jsx(ValidationIndicator, { ...field.validator, children: /* @__PURE__ */ jsx(InputDate, { customConstraintViolationValidator: handleValidation, ...restProps, ...field.input }) });
}

const metaData = {
  name: "postalCode",
  title: "Code postal*",
  type: "text",
  inputMode: "numeric",
  pattern: "[0-9]{5}",
  maxLength: 5,
  masked: /\D/g,
  required: true,
  defaultErrorMessage: "Le code postal doit contenir 5 chiffres"
};
function InputPostalCode(props) {
  return /* @__PURE__ */ jsx(InputTextWithValidation, { ...metaData, ...props });
}

const container = "_container_txlcn_1";
const combobox = "_combobox_txlcn_5";
const valid = "_valid_txlcn_22";
const error = "_error_txlcn_33";
const icon = "_icon_txlcn_37";
const listbox = "_listbox_txlcn_51";
const option = "_option_txlcn_67";
const styles = {
	container: container,
	combobox: combobox,
	valid: valid,
	error: error,
	icon: icon,
	listbox: listbox,
	option: option
};

const findPreviousChildIndex = (currentChildIndex, childrenCount) => {
  const currentSelectedValueIndex = Math.max(0, currentChildIndex);
  return mod(currentSelectedValueIndex - 1, childrenCount);
};
const mod = (index, modulo) => (index % modulo + modulo) % modulo;
const findNextChildIndex = (currentChildIndex, childrenCount) => {
  return (currentChildIndex + 1) % childrenCount;
};
const getSearchStyle = (isPristine, isValid) => ({
  [styles.combobox]: true,
  [styles.error]: !isPristine && !isValid
});
const buildForEnter = (value, selectedValue, setValueInput, setIsListBoxOpen, onChange) => {
  return (inputValidity) => {
    if (selectedValue?.props.clickable !== void 0) {
      return;
    }
    setValueInput(selectedValue?.props.children || value);
    onChange?.(
      selectedValue?.props.children || value,
      inputValidity
    );
    setIsListBoxOpen(false);
  };
};
const buildForEscape = (isListBoxOpen, setIsListBoxOpen, setValueInput, setSelectedValue, onChange) => {
  return () => {
    if (isListBoxOpen) {
      setIsListBoxOpen(false);
      return;
    }
    setValueInput("");
    setSelectedValue(null);
    onChange?.("");
  };
};

function Search({
  id,
  disabled,
  value,
  defaultValue = "",
  onChange,
  required = false,
  placeholder,
  ...restProps
}) {
  const listId = useId();
  const inputRef = useRef(null);
  const [valueInput, setValueInput] = useState(defaultValue);
  const [isListBoxOpen, setIsListBoxOpen] = useState(false);
  const [isListBoxOver, setIsListBoxOver] = useState(false);
  const [isPristine, setIsPristine] = useState(true);
  const [selectedValue, setSelectedValue] = useState(null);
  const _value = value !== void 0 ? value : valueInput;
  const children = Children.toArray(restProps.children).filter((item) => item.type === SearchItem);
  const childrenCount = children.length;
  const onKeyDown = (evt) => {
    keysBindingActions[evt.key]?.();
  };
  const keysBindingActions = {
    ArrowDown: () => {
      setIsListBoxOpen(true);
      const currentChildIndex = children.findIndex(
        (child) => child.key === selectedValue?.key
      );
      const nextIndex = findNextChildIndex(
        currentChildIndex,
        childrenCount
      );
      setSelectedValue(children[nextIndex]);
    },
    ArrowUp: () => {
      setIsListBoxOpen(true);
      const currentChildIndex = children.findIndex(
        (child) => child.key === selectedValue?.key
      );
      const previousIndex = findPreviousChildIndex(
        currentChildIndex,
        childrenCount
      );
      setSelectedValue(children[previousIndex]);
    },
    Enter: () => buildForEnter(_value, selectedValue, setValueInput, setIsListBoxOpen, onChange)(inputRef.current?.validity),
    Escape: buildForEscape(isListBoxOpen, setIsListBoxOpen, setValueInput, setSelectedValue, onChange),
    Tab: () => {
      setIsListBoxOpen(false);
      setSelectedValue(null);
    }
  };
  const onElementClick = (evt) => {
    evt.preventDefault();
    const elm = evt.target;
    setValueInput(elm.innerHTML);
    setIsListBoxOpen(false);
    setIsListBoxOver(false);
    inputRef?.current?.focus();
    onChange?.(elm.innerHTML, inputRef.current?.validity);
  };
  const onChangeInput = (evt) => {
    evt.preventDefault();
    setValueInput(evt.target.value);
    setIsPristine(false);
    onChange?.(evt.target.value, evt.target.validity);
    if (!isListBoxOpen && evt.target.value !== _value) {
      setIsListBoxOpen(true);
    }
    if (evt.target.value < valueInput) {
      setSelectedValue(null);
    }
  };
  const onBlurInput = () => {
    if (!isListBoxOver) {
      setIsListBoxOpen(false);
    }
  };
  const onListMouseLeave = () => setIsListBoxOver(false);
  const onListMouseEnter = () => setIsListBoxOver(true);
  const className = getSearchStyle(isPristine, inputRef.current?.validity.valid || false);
  return /* @__PURE__ */ jsxs("div", { className: styles.container, children: [
    /* @__PURE__ */ jsx(
      "input",
      {
        type: "text",
        id,
        className: classNames(className),
        onClick: () => {
          setSelectedValue(null);
        },
        onChange: onChangeInput,
        onBlur: onBlurInput,
        onKeyDown,
        disabled,
        required,
        role: "combobox",
        "aria-expanded": isListBoxOpen,
        "aria-controls": `dropdown-listbox_${listId}`,
        "aria-activedescendant": getActiveDescendant(selectedValue),
        value: _value,
        placeholder,
        ref: inputRef
      }
    ),
    isListBoxOpen && childrenCount > 0 && /* @__PURE__ */ jsx(
      "ul",
      {
        id: `dropdown-listbox_${listId}`,
        role: "listbox",
        "aria-label": "Liste de résultats de recherche",
        onClick: onElementClick,
        onMouseEnter: onListMouseEnter,
        onMouseLeave: onListMouseLeave,
        className: styles.listbox,
        children: children.map(
          (child) => childPropsMapper(child, selectedValue)
        )
      }
    )
  ] });
}
const childPropsMapper = (child, selectedValue) => {
  if (child.key === selectedValue?.key) {
    return cloneElement(child, { selected: true });
  }
  return child;
};
function getActiveDescendant(selectedValue) {
  return selectedValue ? `dropdown-listbox_${selectedValue?.props.children}` : void 0;
}
function SearchItem({
  children,
  selected = false,
  clickable = true
}) {
  const onClick = (evt) => {
    if (!clickable) {
      evt.stopPropagation();
    }
  };
  return /* @__PURE__ */ jsx(
    "li",
    {
      id: `dropdown-listbox_${children}`,
      className: styles.option,
      role: "option",
      "aria-selected": selected,
      "data-clickable": clickable,
      onClick,
      children
    }
  );
}

export { AssistiveText, Input, InputCity, InputDate, InputDateWithValidation, InputLabel, InputPostalCode, InputTextWithValidation, Search, SearchItem, ValidationIndicator, toEnglishFormat, useAutofill, useValidation };
